<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
            <div class="modal-container" style="max-height:100vh;overflow-y:scroll;">

              <div class="modal-header">
                <slot name="header">
                  BRANDED ARTICLE DETAILS
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  Location
                  <div class="input-box">
                    <select v-model="newBrand.location">
                      <option value="">Please Select Location</option>
                      <option :key="state.text" v-for="state in states" :value="state.text">
                        {{ state.text }}
                      </option>
                    </select>
                  </div>
                  Branded article slug
                  <div class="input-box">
                    <input type="text" v-model="newBrand.url">
                  </div>
                  Pageviews needed
                  <div class="input-box">
                    <input type="number" v-model="newBrand.pageviews">
                  </div>
                  Current pageviews
                  <div class="input-box">
                    <input type="number" v-model="newBrand.currentPageviews">
                  </div>
                  Pageviews needed by which date?
                  <div class="input-box">
                     <input type="date" v-model="newBrand.endDate">
                  </div>
                  Probability
                  <div class="input-box">
                    <input type="number" v-model="newBrand.probability">
                  </div>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button" @click="addNewBrand">
                    ADD ARTICLE
                  </button>
                  <button class="modal-default-button" @click="closeTheModal">
                    CANCEL
                  </button>
                </slot>
              </div>
            </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from "vue";
import firebase from 'firebase';
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
  export default {
    components: {
    },
    props: ['passedValue'],
    name: 'modal',
    firestore() {
      return {
      };
    },
    data: function() {
      firestore = firebase.firestore();
      return {
        states: [{text:"New South Wales"}, {text:"Queensland"}, {text:"South Australia"}, {text:"Victoria"}, {text:"Western Australia"}],
        newBrand: {
          active:true,
          endDate:'',
          currentPageviews: 0,
          pageviews:0,
          probability:0,
          url:"",
          location: ""
        }
      }
    },
    methods: {
      addNewBrand() {
        //Calculating probability
        var actualValue = true;
        var currentDate = Math.floor(Date.now() / 1000);
        var newDate = new Date(this.newBrand.endDate).getTime() / 1000;
        var noOfDays = Math.floor((newDate - currentDate )/ 86400);
        var pvPerDay = (this.newBrand.pageviews - this.newBrand.currentPageviews) / noOfDays ;
        //The number 900 has been taken based on an estimate of 9,000 available page views for adding branded articles under.
        //This number is roughly 10% of daily pageviews.Can be tweaked if the daily page views change a lot
        var probValue = (pvPerDay / 90).toFixed(2);
        var probNumber = parseFloat(probValue);
        var totalProb = this.$props.passedValue + probNumber;
        console.log(totalProb);
        // if(20 >= totalProb ){
          //console.log('Total less than 10 : '+totalProb);
          this.newBrand.probability = parseFloat(probNumber);
        // } else {
        //   console.log('Total more than 10 :'+totalProb);
        //   actualValue = false;
        //   this.newBrand.probability = parseFloat((20 - this.$props.passedValue));
        // }
        console.log('This is the probability that will be added : ' + this.newBrand.probability);
        this.newBrand.pageviews = parseInt(this.newBrand.pageviews);
        this.newBrand.currentPageviews = parseInt(this.newBrand.currentPageviews);

        firestore.collection('brandedArticles').add(this.newBrand)
        .then(ref => {
          console.log('Added document with ID: ', ref.id);
          if(actualValue){
            alert("New branded article created");
          } else {
            alert("New branded article created. The probabilty value was adjusted as the there are too many competing branded articles. This may not meet its target.");
          }

          this.newBrand = {
            active:true,
            currentPageviews: 0,
            endDate:'',
            pageviews:0,
            probability:0,
            url:"",
            location:"",
          };
          this.$emit('update:modal');
        });
      },
      closeTheModal() {
          this.$emit('update:modal');
      }
    }
  }
</script>

<style>
.result em {
  background-color: #ccc;
  color:black;
}

</style>

<style scoped>
.flex-row {
  display:flex;
}
input {
  display:block;
}
.modal-mask {
  overflow-y:scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  color:#000000;
  text-align:center;
}

.modal-body {
  margin: 20px 0;
  color:#000000;
}

.modal-default-button {
  float: right;
}
.modal-footer {
  padding:10px;
}
.modal-footer button {
  margin-right:10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
}
.scrolling-wrapper-flexbox {
    display: flex;
    flex-wrap: nowrap;

    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
input {
      width: 500px;
}
</style>


// WEBPACK FOOTER //
// ModalBranded.vue?d5c25836